<template>
  <section class="section">
    <div id="app" class="container">
      <h1 class="title">{{ tradeName + " - " + symbol }}</h1>
      <div class="tabs">
        <ul>
          <li
            v-for="tab in tabs"
            v-bind:key="tab"
            v-bind:class="{ 'is-active': (tab == activeTab) }"
          >
            <a v-on:click="setActive(tab)">{{ $t('app.' + tab) }}</a>
          </li>
        </ul>
      </div>
      <div v-if="activeTab == 'overview'">
        <div class="columns is-tablet">
          <div class="column is-three-fifths">
            <SirketDetay />
            <br />
            <SirketHaber limit="5" />
          </div>
          <div class="column is-two-fifths">
            <LineChart />
            <br />
            <Gundem />
          </div>
        </div>
      </div>
      <div v-if="activeTab == 'profile'">
        <SirketProfil />
      </div>
      <div v-if="activeTab == 'graph'">
        <Chart />
      </div>
      <div v-if="activeTab == 'news'">
        <SirketHaber />
      </div>
      <div v-if="activeTab == 'capital'">
        <SirketSermaye />
      </div>
      <div v-if="activeTab == 'profit'">
        <Getiri />
      </div>
      <div v-if="activeTab == 'balance_sheet_detail'">
        <BilancoDetay />
      </div>
      <div v-if="activeTab == 'balance_sheet_ratio'">
        <BilancoRasyo />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Gundem from "./components/Gundem.vue";
import Chart from "./components/Chart.vue";
import LineChart from "./components/LineChart.vue";
import BilancoDetay from "./components/BilancoDetay.vue";
import BilancoRasyo from "./components/BilancoRasyo.vue";
import SirketProfil from "./components/SirketProfil.vue";
import SirketSermaye from "./components/SirketSermaye.vue";
import SirketDetay from "./components/SirketDetay.vue";
import SirketHaber from "./components/SirketHaber.vue";
import Getiri from "./components/Getiri.vue";

export default {
  name: "app",
  computed: {
    ...mapState(["symbol", "tradeName"])
  },
  components: {
    Gundem,
    Chart,
    LineChart,
    BilancoDetay,
    BilancoRasyo,
    SirketProfil,
    SirketSermaye,
    SirketDetay,
    SirketHaber,
    Getiri
  },
  data: function() {
    return {
      tabs: [
        "overview",
        "profile",
        "graph",
        "news",
        "capital",
        "profit",
        "balance_sheet_detail",
        "balance_sheet_ratio"
      ],
      activeTab: "overview",
      lang: "tr",
      companyurl: process.env.VUE_APP_COMPANYURL,
      companyname: process.env.VUE_APP_COMPANYNAME
    };
  },
  created() {
    let searchParams = new URLSearchParams(window.location.search);
    this.setSymbol(searchParams.get("symbol"));
    if (searchParams.get("lang") == "en") {
      this.$i18n.locale = "en";
    }
  },
  methods: {
    setActive: function(tab) {
      this.activeTab = tab;
    },
    ...mapMutations(["setSymbol"])
  }
};
</script>
